/* eslint-disable @typescript-eslint/no-explicit-any */
// A mock implementation of the Sumsub WebSDK for testing purposes
// Usage: Replace @sumsub/websdk with this mock in your tests

import { type Component, createApp } from 'vue';
import type { ApplicantStatusChangedPayload } from '@/integrations/Sumsub/types';

export class MockSnsWebSdkInstance {
  private handlers: Record<string, (payload?: any) => void> = {};
  private component: Component;
  private conf: Record<string, any> = {};
  private options: Record<string, any> = {};

  constructor(props: { component: Component }) {
    this.component = props.component;
  }

  withConf(conf: Record<string, any>) {
    this.conf = conf;
    return this;
  }

  withOptions(options: Record<string, any>) {
    this.options = options;
    return this;
  }

  on(event: string, handler: (payload?: any) => void) {
    this.handlers[event] = handler;
    return this;
  }

  build() {
    return this;
  }

  launch(containerSelector: string) {
    // Remove # if present in selector
    const elementId = containerSelector.replace('#', '');
    const targetEl = document.getElementById(elementId);

    if (!targetEl) {
      throw new Error(`Element with id ${containerSelector} not found`);
    }

    // Create a Vue app instance for that component
    const app = createApp(this.component, { webSdkInstance: this });

    // Mount it
    app.mount(targetEl);
  }

  // Utility for tests to trigger events
  trigger(event: string, payload?: any) {
    if (this.handlers[event]) {
      this.handlers[event](payload);
    }
  }

  // Method to simulate applicant status changes
  emitApplicantStatusChanged(payload: ApplicantStatusChangedPayload) {
    this.trigger('idCheck.onApplicantStatusChanged', payload);
  }

  // Getter methods to access stored configuration (for testing)
  getConf() {
    return this.conf;
  }

  getOptions() {
    return this.options;
  }
}

export class MockSnsWebSdk {
  private component: Component;

  constructor(props: { component: Component }) {
    this.component = props.component;
  }

  init(_accessToken: string, _refreshTokenFn: () => string | Promise<string>) {
    // Parameters are intentionally unused as this is a mock - they would be used in the real implementation
    return new MockSnsWebSdkInstance({ component: this.component });
  }
}
